import styled from 'styled-components';
import { Layout }                    from 'antd';
import { highlightColor, secondaryFontColor, white, primaryColor, fontColor } from 'Public/Css/colors';

export default styled(Layout.Sider) `

  .sidebarLogo {
    white-space: nowrap;
    height: auto;

    img {

      margin: 0 auto;
      display: block;
      padding: 8px;
      max-width: 100%;
      height: auto;
    }

    h3 {
      color: ${ white };
      text-align: center;
      font-weight: bold;
      font-size: 22px;
      padding-top: 12px;
      margin: 0;
      letter-spacing: 0;
    }
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
  }
    
  .ant-menu {
    height: calc(100% - 48px);

    background-color: transparent;
    border: none;
    position: relative;
    display: flex;
    flex-direction: column;
      
    &.ant-menu-inline-collapsed {
        .ant-menu-item {
          padding: 0;
          height: 48px;
          line-height: 48px;

          > span {
           display: inline-flex;
           height: 100%;

           > span {
            width: 100%;
            height: 100%; 
           }

            a {
              display: inline-flex;
              justify-content: center; 
              align-items: center;
              width: 100%;
              height: 100%;

              span:not(.anticon) {
                display: none;
              }

              .anticon {
                margin: 0;
                display: flex;
              }
            }
          }
        }
    }
  }
    
  .ant-menu-item {
    border-radius: 0 !important;
    color: ${ white };
    text-transform: uppercase;
    margin: 0;
    padding: 0 16px;
    width: 100%;
    height: 56px;
    line-height: 56px;

    &:last-child {
      margin-top: auto;
    }

    &:hover, &:focus, &:active, &:visited {
      background-color: ${ secondaryFontColor } !important;
      width: calc(100% + 1px) !important;
      border-radius: 0 !important;
        
      a {
        color: ${ white };
      }
    }
    
    & > span {
      width: 100%;
      //margin-left: -16px;
      display: inline-block;
      
      a {
        display: inline-block;
        color: ${ white };
      }
    }

    &.ant-menu-item-selected {
      background-color: ${ highlightColor };
      width: calc(100% + 1px) !important;
      border-radius: 0 !important;
      
      > span a {
        color: ${fontColor};
      }

      &:hover {
        > span a {
          color: ${white};
        }
      }
    }

    .anticon {
      margin: 0 8px 0 0;
      font-size: 20px;
    }
    
    > span a {
      font-family: 'Noto Sans Display', ui-sans-serif, system-ui, sans-serif;
      font-weight: 700;
      letter-spacing: 1px;
      font-site: 12px;
      color: ${ white };
      display: inline-flex;
      align-items: center;
    }
  }
    
`;
